import React from 'react';
import { useState, useEffect, useRef, useCallback } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonIcon, IonModal, IonList, IonLabel, IonItem } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { Loader } from 'citric_components';
import Summary from '../Summary/Summary';
import {Button, Row, Col} from 'react-bootstrap';
import PaginationTable from '../Table/PaginationTable';

import { App } from '@capacitor/app';

import { Avatar, CustomTable } from 'citric_components';

import CardImg from '../../images/card.png';
import { useNavigate, useLocation } from 'react-router';

import conf from '../../config.json';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faRotate } from '@fortawesome/free-solid-svg-icons';
import { generateKey, logD } from '../Util/Util';
import { isCATI } from '../Releases/Releases';
import "ol/ol.css";
import Map from 'ol/Map';
import Overlay from 'ol/Overlay.js';
import View from "ol/View";
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from "ol/source/Vector.js";
import OSM from "ol/source/OSM";
import {fromLonLat} from 'ol/proj.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Icon from 'ol/style/Icon.js';
import Style from 'ol/style/Style.js';
import Marker from '../../images/map-marker-48.png';
import Header from '../Dashboard/Header';

export default function Responses(props) {
    logD("Responses", props);
    const [responses, setResponses] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(props.total != null ? Math.ceil(props.total / 50) : 0);
    const fetchIdRef = useRef(0);

    //const [reload, setReload] = useState(props.reload);
    //const reload = props.reload;
    const launch = props.launch;
    var hiddenColumns = ['idResponse', 'interviewed', 'followup', 'remoteuser'];

    if(launch.idType == 6) {
        hiddenColumns = ['idResponse', 'note', 'remoteuser'];
    } else if(launch.idType == 2) {
        hiddenColumns = ['note', 'interviewed', 'followup'];
    }

    const navigate =useNavigate();
    const location = useLocation();

    const summaryData = {};
    summaryData.id_form = props.launch.release.idDraft;
    summaryData.plannings = [props.launch.idLaunch];
    summaryData.lang_code = props.lang;

    const fetchData = useCallback(({ pageSize, pageIndex }) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true)

        // We'll even set a delay to simulate a server here
        setTimeout(() => {
        // Only update the data if this is the latest fetch
        if (fetchId === fetchIdRef.current) {
            /*const startRow = pageSize * pageIndex
            const endRow = startRow + pageSize
            setData(serverData.slice(startRow, endRow))

            // Your server could send back total page count.
            // For now we'll just fake it, too
            setPageCount(Math.ceil(serverData.length / pageSize))*/
            getResponses(pageSize, pageIndex);

            setLoading(false);
        }
        }, 1000)
    }, [])

    function back() {
        
        //setResponses(null);
        //props.setLaunch(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    App.addListener('backButton', ({canGoBack}) => {
          
          if(!canGoBack){
            App.exitApp();
          } else {
            back();
          }
    });

    function showFollowup(item) {
        
        setSelected(item);
        setTimeout(function(){
            setModalOpen(true);
        }, 1);
    }

    function getResponses(pageSize, pageIndex) {
        let fd = new URLSearchParams();
        fd.append("idL", launch.idLaunch);
        fd.append("idU", props.interviewer);
        fd.append("pageSize", pageSize);
        fd.append("pageIndex", pageIndex);
        var url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allResponses'; //allResponses
        if(props.total <= 200 && props.interviewer == null) {
            url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allResponsesL'; //allResponses
        } else if(props.total > 200) {
            url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/responsesPaging'; //allResponses
            if(props.interviewer == null)
                url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/responsesLPaging'; //allResponsesL
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("getResponses", data);
            setResponses(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function reload() {
        if(launch != null && props.total <= 200) {
            setResponses(null);
            getResponses();
        }
    }

    useEffect(() => {
        if(launch != null && props.total <= 200) {
            getResponses();
        }
    }, [])

    /*useEffect(() => {
        if(responses != null && (launch.geolocation || launch.constantGeolocation)) {
            const iconStyle = new Style({
                image: new Icon({
                  anchor: [0.5, 46],
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'pixels',
                  src: Marker,
                }),
            });

            var markers = new Array();

            for(var i in responses) {
                var response = responses[i];
                if(response.geolocation != null) {
                    const coordinates = response.geolocation.split(";");
                    const iconFeature = new Feature({
                        id: response.idResponse,
                        geometry: new Point(fromLonLat([coordinates[1], coordinates[0]])),
                        name: response.idResponse,
                    });
                    iconFeature.setStyle(iconStyle);
                    markers.push(iconFeature);
                }
            }
              
            const vectorSource = new VectorSource({
                features: markers,
            });
              
            const vectorLayer = new VectorLayer({
                source: vectorSource,
            });

            const map = new Map({
                target: "map",
                layers: [
                  new TileLayer({
                    source: new OSM(),
                  }), vectorLayer
                ],
                view: new View({
                  center: fromLonLat([-3.703333, 40.416667]),
                  zoom: 5.5,
                }),
            });

            map.on('click', function (evt) {
                const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                    return feature;
                });

                if (!feature) {
                    return;
                }

                var globalFilter = document.getElementsByName("globalFilter");
                if(globalFilter.length > 0) {
                    console.log(feature.values_.id);
                    globalFilter[0].value = feature.values_.id;
 
                    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                        window.HTMLInputElement.prototype,
                        'value').set;
                      nativeInputValueSetter.call(globalFilter[0], feature.values_.id);
                    const event = new Event('input', { bubbles: true })
                    globalFilter[0].dispatchEvent(event)
                }
                console.log(feature);
            });

            // change mouse cursor when over marker
            map.on('pointermove', function (e) {
                const hit = map.hasFeatureAtPixel(e.pixel);
                map.getTargetElement().style.cursor = hit ? 'pointer' : '';
            });
        }
    }, [responses]);*/

    /*useEffect(() => {
        if(launch != null && location.pathname.includes('/history')) {
            //locationKey = location.key;
            getResponses();
        }
    }, [location]);*/

    const columns = [
        {
            Header: t('id'),
            accessor: 'idResponse',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                if(d.ddState == 1) {
                    return <IonButton color="primary" onClick={ (e) => { 
                            e.preventDefault();
                            //props.setLaunch(launch);
                            //setResponses(null);
                            //props.setReload(true);
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=portalEncuesta');
                            props.setTitle(launch.release.name + " - " + launch.description);
                            props.setTypeUrl('survey');
                            setTimeout(function(){
                                navigate('../webview/'+d.idResponse);
                            }, 100);
                            //var url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=portalEncuestaMod';
                            //InAppBrowser.create(url, "_self", {});
                            //openURLInNewTab(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/answer/e?elec=form&accion=cargar&planifciacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=portalEncuesta');
                        }
                    }>{t('continue')}</IonButton>
                } 
                if((d.ddState == 2 || d.ddState == 3 || d.ddState == 4 || d.ddState == 5 || d.ddState == 6) && props.token.r == 1) {
                    return <>{<IonButton color="secondary" onClick={ (e) => { 
                            e.preventDefault();
                            props.setUrl(conf.BEprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=revision');
                            props.setTitle(launch.release.name + " - " + launch.description);
                            setTimeout(function(){
                                navigate('/dashboard/webview/'+d.idResponse);
                            }, 1);
                        }
                    }>{t('review')}</IonButton>}</>
                }
            }
        },
        {
            Header: t('remoteuser'),
            accessor: 'remoteuser',
        },
        {
            id: 'interviewed',
            Header: t('interviewed'),
            accessor: (d) => {
                if(d.interviewed && d.interviewed != null) {
                    return [d.interviewed.name,d.interviewed.tlf];
                } else {
                    return ['',''];
                }
            },
            Cell: ({value}) => {
                const [ name, tlf ] = value
                return name + ' ' + (tlf ? tlf : '');
            }
        },
        {
            id: 'followup',
            Header: t('followup'),
            accessor: (d) => {
                if(d.interviewed && d.interviewed != null && d.interviewed.followup && d.interviewed.followup != null && d.interviewed.followup.length > 0) {
                    return ([new Date(d.interviewed.followup[0].tmpcreacion).toLocaleString(navigator.language), 
                        t(d.interviewed.followup[0].ddAcctionDto.codigo), 
                        d.interviewed.followup[0].cita != null ? new Date(d.interviewed.followup[0].cita).toLocaleString(navigator.language) : '',
                        d.interviewed.followup[0].texto != null ? d.interviewed.followup[0].texto : '']);
                } else {
                    return (['', '', '', '']);
                }
            },
            Cell: (props) => {
                console.log(props);
                const [ date, code, appointment, note ] = props.value;
                    return <>
                        <span>{date}</span>
                        <br/>
                        <span>{code} {appointment}</span>
                        <br />
                        <span>{note}</span>
                        <Button variant="link"><FontAwesomeIcon icon={faEye} onClick={() => showFollowup(props.row.original)}/></Button></>;

            }
        },
        {
            Header: t('note'),
            accessor: 'note',
        },
        {
            id: 'ddState',
            Header: t('state'),
            accessor: (d) => {
                if(d.ddState == 1) {
                    return t('dropout')
                } else if(d.ddState == 2) {
                    return t('complete')
                } else if(d.ddState == 3) {
                    return t('screenout')
                } else if(d.ddState == 4) {
                    return t('quotafull')
                } else if(d.ddState == 5) {
                    return t('qualityout')
                } else if(d.ddState == 6) {
                    return t('timeout')
                }

            }
        },
        {
            id: 'started',
            Header: t('started'),
            sortType: (a, b) => {
                return b.original.started - a.original.started;
            },
            accessor: (d) => {
                if(d.started == null) {
                    return '';
                } else {
                    return new Date(d.started).toLocaleString(navigator.language);
                }
            },

        }, {
            id: 'modified',
            Header: t('modified'),
            sortType: (a, b) => {
                return b.original.modified - a.original.modified;
            },
            accessor: (d) => {
                if(d.modified == null) {
                    return '';
                } else {
                    return new Date(d.modified).toLocaleString(navigator.language);
                }
            },
        }, {
            id: 'finished',
            Header: t('end'),
            sortType: (a, b) => {
                var l = b.original.finished != null ? b.original.finished : b.original.modified;
                var f = a.original.finished != null ? a.original.finished : a.original.modified;
                return l - f;
            },
            accessor: (d) => {
                if(d.finished == null) {
                    return '';
                } else {
                    return new Date(d.finished).toLocaleString(navigator.language);
                }
            },
        },
    ];

    return (
        <>
            <IonPage id="responses">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                        </IonButtons>
                        <IonTitle>{launch.release.name + " - " + launch.description}</IonTitle>
                        <IonButtons slot="end">
                            {!isCATI(launch) && <IonButton color="primary" onClick={ (e) => { 
                                    e.preventDefault();
                                    //setResponses(null);
                                    var keyNote = generateKey(launch.idLaunch);
                                    props.setKeyNote(keyNote);
                                    props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/a/' + launch.urls[0].data + "?note=" + keyNote);
                                    props.setTitle(launch.release.name + " - " + launch.description);
                                    props.setTypeUrl('survey_start');
                                    setTimeout(function(){
                                        navigate('../webview/'+launch.idLaunch);
                                    }, 100);
                                    //openURLInNewTab(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/answer/a/' + launch.urls[0].data);
                                }
                            }>
                                {t('start_survey')}
                            </IonButton>}
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <Row className="text-end">
                        <Col>
                            <Button variant="link"><FontAwesomeIcon icon={faRotate} onClick={() => reload()}/></Button>
                        </Col>
                    </Row>
                    {/*responses.length > 0 && <Summary data={summaryData} lang={props.lang} loi={false} handleError={props.handleError}/>*/}
                    {/*responses.length > 0 && (launch.geolocation || launch.constantGeolocation) && <div id="map" style={{width: "100%", height: "400px"}}><div id="popup"></div></div>*/}
                    {/*responses.length === 0 && <Loader />*/}
                    {props.total <= 200 && <CustomTable keyField='started' desc={false} data={responses} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true} pageLength={50} />}

                    { props.total > 200 && <PaginationTable
                        columns={columns}
                        data={responses}
                        hiddenColumns={hiddenColumns}
                        pageLength={50}
                        fetchData={fetchData}
                        loading={loading}
                        pageCount={pageCount}
                    />}
                    
                    <IonModal isOpen={modalOpen}>
                        <IonHeader>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton onClick={() => setModalOpen(false)}>{t('close')}</IonButton>
                                </IonButtons>
                                <IonTitle>{selected != null ? selected.interviewed.name + ' ' + selected.interviewed.tlf : ''}</IonTitle>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonList>
                            {
                                selected != null && selected.interviewed.followup.map(function(item) {
                                    return <IonItem>
                                                <IonLabel>{new Date(item.tmpcreacion).toLocaleString(navigator.language)}</IonLabel>
                                                <IonLabel>{item.ddAcctionDto.codigo} {item.cita != null ? new Date(item.cita).toLocaleString(navigator.language) : ''}</IonLabel><br/>
                                                <IonLabel>{item.texto != null ? item.texto : ''}</IonLabel>
                                            </IonItem>
                                })
                            }
                            </IonList>
                        </IonContent>
                    </IonModal>
                </IonContent>
            </IonPage>
        </>
    );
}